export default __webpack_public_path__ + "static/media/poster.4acdf357.webp";